import React, {Component} from 'react'
import {Button, Modal, Table} from "antd";
import {uuid} from "../utils";
import {post} from "../actions";
/**
 * 多选,  弹出选择框表格，
 */
class CheckBoxTableModal extends  Component{
    constructor(props){
        super(props);
        this.state={
            currentPage:1,
            tableData:{},
            selectkeys:[],
        }
    }

    selectedRowKeys=[];

    componentWillReceiveProps(nextProps){
        if(nextProps.selectedRowKeys !== this.props.selectedRowKeys){
            this.setState({
                selectkeys: nextProps.selectedRowKeys
            })
        }
        if(nextProps.visible){
            this.setState({
                currentPage: 1,
            }, () => {
                window.loading.show();
                this.getTableData(()=>{
                    window.loading.hide();
                });
            })
        }
    }

    /**
     * 确定按钮事件
     */
    submitOk(){
        let selectRows = [];

        this.allSelectedRows.map(item=>{
            let isAdd = false;
            this.selectedRowKeys.map(id=> {
                if (id === item.id) {
                    isAdd = true;
                }
            });
            if(isAdd){
                selectRows.push(item);
            }
        });
        this.props.onOk(selectRows);
    }

    cancel(){
       this.props.closeModal();
    }

    componentDidMount() {
        window.loading.show();
        this.getTableData(()=>{
            window.loading.hide();
        });
    }

    /**
     * 获取综合活动数据
     */
    getTableData(callBack){
        let param=this.props.dataParam;
        let url=this.props.dataUrl;
        post(url,param,(data)=>{
            if(callBack){
                callBack();
            }
            this.setState({
                tableData:data,
            })
        });
    }

    //点击分页事件。
    onTableChange(pagination){
        let formData={
            "start":pagination.current,
            "size":pagination.pageSize,
            "currentTime":new Date().getMilliseconds(),
            ...this.props.dataParam
        };
        this.state.currentPage=pagination.current;
        let url=this.props.dataUrl;
        post(url, formData, (data) => {
            this.setState({
                tableData: data,
            })
        });
    }

    allSelectedRows = [];//所有被选中过的行, onChange: (selectedRowKeys, selectedRows)这个方法中的selectedRows翻页的时候数据被清空了。

    render() {
       const  rowSelection = {
            selectedRowKeys: this.state.selectkeys,
            onChange: (selectedRowKeys, selectedRows) => {
                selectedRows && selectedRows.map(selectedRow=>{
                    let isAdd = true;
                    this.allSelectedRows.map(allSelectedRow=>{
                        if(selectedRow.id === allSelectedRow.id){
                            isAdd = false;
                        }
                    });
                    if(isAdd){
                        this.allSelectedRows.push(selectedRow);
                    }
                });

                this.selectedRowKeys=selectedRowKeys;
                this.setState({
                    selectkeys:selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };

        const bottomButton = [
            <Button className={"cancel"} key={uuid()} onClick={() => {
                this.cancel()
            }}>
                取消
            </Button>,<Button type="primary" className={"submitOk"} key={uuid()} onClick={() => {
                this.submitOk()
            }}>
                确定
            </Button>];
        return <Modal
            onCancel={this.cancel.bind(this)}
            title={this.props.title}
            visible={this.props.visible}
            footer={[
                bottomButton
            ]}
            keyboard={false}
            maskClosable={false}
            centered={true}
            width={'65%'}
            className={'checkBoxTable'}
        >
            <div style={{padding:'20px'}}>
            <Table columns={this.props.columns}  dataSource={this.state.tableData.data}
                   rowSelection={rowSelection}
                   rowKey={record=>record.id}
                  // selectedRowKeys={this.props.selectedRowKeys}
                   pagination={{'total':this.state.tableData.count,'current':this.state.currentPage}} scroll={{y: 400 }}
                   onChange={this.onTableChange.bind(this)}/>
            </div>
        </Modal>
    }
}

export  default   CheckBoxTableModal;